import { useEffect } from "react";

const REVEAL_ATTR = "data-reveal";
const REVEALED_CLASS = "is-revealed";
const ROOT_CLASS = "js-reveal";

if (typeof document !== "undefined") {
  document.documentElement.classList.add(ROOT_CLASS);
}

export function useReveal(deps: ReadonlyArray<unknown> = []) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const nodes = Array.from(document.querySelectorAll<HTMLElement>(`[${REVEAL_ATTR}]`));
    if (reduce || typeof IntersectionObserver === "undefined") {
      nodes.forEach((n) => n.classList.add(REVEALED_CLASS));
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add(REVEALED_CLASS);
            obs.unobserve(e.target);
          }
        });
      },
      { rootMargin: "-8% 0px -10% 0px", threshold: 0.01 },
    );
    nodes.forEach((n) => obs.observe(n));
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
